var map = {
	"./CABA.svg": 43,
	"./Cordoba.svg": 44,
	"./Mendoza.svg": 27,
	"./Salta.svg": 45,
	"./SantaFe.svg": 46,
	"./Tigre.svg": 47,
	"./banda-del-rio.svg": 48,
	"./buenos-aires.svg": 49,
	"./corrientes.svg": 50,
	"./la-matanza.svg": 51,
	"./mar-del-plata.svg": 52,
	"./monteros.svg": 53,
	"./san-isidro.svg": 54,
	"./tucuman.svg": 55,
	"./vicente-lopez.svg": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;